var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.045 18.895a10.95 10.95 0 00-2.587-3.49 12.082 12.082 0 00-3.811-2.337 12.05 12.05 0 00-.944-.321 6.91 6.91 0 10-7.406 0 12.72 12.72 0 00-.944.32 12.082 12.082 0 00-3.81 2.337 10.95 10.95 0 00-2.588 3.491A10.126 10.126 0 000 23.196a.804.804 0 001.607 0c0-2.49 1.071-4.834 3.016-6.602a10.48 10.48 0 013.307-2.026 11.29 11.29 0 014.046-.747h.048c1.404.003 2.765.254 4.046.747a10.48 10.48 0 013.307 2.026c1.945 1.768 3.016 4.113 3.016 6.602a.804.804 0 001.607 0c0-1.492-.321-2.939-.955-4.3zM8.25 10.661a5.269 5.269 0 01-1.554-3.75A5.27 5.27 0 018.25 3.16 5.269 5.269 0 0112 1.607c1.417 0 2.748.552 3.75 1.554a5.269 5.269 0 011.554 3.75 5.27 5.27 0 01-1.554 3.75 5.268 5.268 0 01-3.718 1.553h-.064a5.268 5.268 0 01-3.718-1.553z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.7f40f235.svg";
export { ForwardRef as ReactComponent };